import { useState } from "react";
import { useSelector } from "react-redux";
import { downloadPdf } from "../../Actions/FileManagerAction";
import { FileManager, ServerAddress } from "../../Enum/Urls";

const DownloadVoucher = props => {
    
    const Dictionary = useSelector(state => state.VisualData.Dictionary);
    const LAN = useSelector(state => state.VisualData.LAN);

    const token = localStorage.getItem("userToken");

    const [loading, setLoading] = useState(false);

    const clickHandle = async () => {
        setLoading(true);
        setLoading(true);
        
        const response = await downloadPdf({
            Type:"HotelVoucher",
            ReserveId: props.ReserveId,
            Username: props.Username
        }, {
            LAN:LAN , 
            token:token,
            currency: props.currency || "USD"
        });

        debugger;
        if (response?.data?.result) {
            
            debugger;

            setLoading(false);

            const url = `${ServerAddress.Type}${ServerAddress.GetPdf}${FileManager.GetPdf}/DownloadTempFile?fileName=${response.data.result.fileName}&fileType=${response.data.result.fileType}&fileToken=${response.data.result.fileToken}  `;
            let a = document.createElement('a');
            a.href = url;
            a.click();
        }


        


        debugger;
    }

    return(
        <>
            <button
                onClick={clickHandle}
                type="button"
                className={`button color-1-btn small-btn nowrap margin-start-half`}
                //href={`http://voucher.imt.as/en/Hotel/Voucher?reserveId=${item.id}&username=${userData.userName}`}
            >
                {Dictionary.GetVoucher}  
                {loading? <span className="loading-inline-circle xxsmall margin-start-light" /> :null}
            </button>
        </>
    )
}

export default DownloadVoucher;